import { createFileRoute } from '@tanstack/react-router'
import NewInvoice from '@/pages/NewInvoice'

export const Route = createFileRoute('/_authenticated/invoices/new')({
  component: NewInvoice,
})
